<template>
    <div class="id-number-check-step-container">
        <div class="title">{{ $t('message.passwordRecovery.idNumberCheckStep.title') }}</div>
        <div class="break-line"></div>
        <div class="step-block">
            <div class="input-block">
                <BaseTextInput
                    :name="'national_id_number'"
                    :placeholder="$t('message.passwordRecovery.idNumberCheckStep.idNumber.placeholder')"
                    v-model="national_id_number"
                />
            </div>
            <div class="btn-block">
                <BaseButton
                    :text="$t('message.passwordRecovery.idNumberCheckStep.idNumber.btn')"
                    :disabled="isBtnDisabled"
                    @click="idNumberCheckStep()"
                />
            </div>
        </div>
    </div>
</template>

<script>
import BaseTextInput from '../../components/base/BaseTextInput.vue';
import BaseButton from '../../components/base/BaseButton.vue';

export default {
    name: 'IdNumberCheckStep',
    components: {
        BaseTextInput,
        BaseButton
    },
    data() {
        return {
            national_id_number: ''
        };
    },
    computed: {
        isBtnDisabled() {
            return !this.national_id_number;
        }
    },
    methods: {
        idNumberCheckStep() {
            this.$emit('idNumberCheckStep', this.national_id_number);
        }
    }
};
</script>

<style lang="scss" scoped>
.id-number-check-step-container {
    @include base-recovery-password-step-container;
}

.title {
    @include recovery-password-title;
    margin-bottom: 25px;
}

.break-line {
    @include recovery-password-break-line;
}

.step-block {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.input-block {
    width: 370px;
}

.btn-block {
    width: 150px;
    height: 54px;
}

@media screen and (max-width: 750px) {
    .id-number-check-step-container {
        padding: 0 5%;
    }

    .step-block {
        flex-direction: column;
        align-items: flex-start;
    }

    .input-block {
        max-width: 100%;
    }
}
</style>
